// extracted by mini-css-extract-plugin
export var attachment = "_pi-a";
export var emailContainer = "_pi-4";
export var emailContentPaddedContainer = "_pi-b";
export var emailHeader = "_pi-6";
export var emailIframe = "_pi-3";
export var emailInfoIcon = "_pi-9";
export var emailShortenedSummary = "_pi-e";
export var infoDropdown = "_pi-0";
export var infoRowBoundedContent = "_pi-d";
export var internal = "_pi-5";
export var merchant = "_pi-8";
export var messageInputContainer = "_pi-h";
export var normal = "_pi-7";
export var replyCard = "_pi-f";
export var subtleButton = "_pi-1";
export var subtleButtonIconContainer = "_pi-2";
export var toggleViewRepliesButton = "_pi-c";
export var wrappingText = "_pi-g";